
import {
  isLocalStorageEnabled,

  getDataFromLocalStorage,

  setDataToLocalStorage,

  removeDataFromLocalStorage,
} from "app/local_storages/native_api_adapter"

const PAGE_TYPE_PLACEHOLDER = "%page_type%"
const COMMON_KEY = `app/page_visit_count_tracker_per_page_type/${PAGE_TYPE_PLACEHOLDER}/.value`

class TrackerPerPageType {
  private page_type_identifier: string

  constructor(page_type_identifier: string) {
    this.page_type_identifier = page_type_identifier
  }

  public getValue() {
    if (!isLocalStorageEnabled()) { return 0 }

    // String
    const value_from_cookie = getDataFromLocalStorage(this.getKey()).data
    if (typeof value_from_cookie !== "string") { return 0 }

    const parsed_integer = parseInt(value_from_cookie, 10)
    if (isNaN(parsed_integer)) { return 0 }

    return parsed_integer
  }

  public incrementValue() {
    const new_value = this.getValue() + 1
    return setDataToLocalStorage(this.getKey(), new_value.toString())
  }

  public resetValue() {
    return removeDataFromLocalStorage(this.getKey())
  }

  private getKey() {
    // https://stackoverflow.com/a/17606289/838346
    return COMMON_KEY.split(PAGE_TYPE_PLACEHOLDER).join(this.page_type_identifier)
  }
}

export default TrackerPerPageType
